import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { lazy } from 'react';
import { registerElitaDealViewExtensions } from './extensions/ElitaDealViewExtension';
import { registerElitaWelcomeExtensions } from './extensions/ElitaWelcomeExtension';
import { registerElitaLeadViewExtensions } from './extensions/ElitaLeadViewExtension';
import {
  IconRefresh,
  IconPackage,
  IconTag,
  IconFolder,
  IconBuildingWarehouse,
  IconCoin,
  IconList,
  IconAdjustments,
  IconListDetails,
  IconClipboardList,
} from '@tabler/icons-react';

/**
 * Регистрация клиентской части модуля elita.
 * Группа "Обмен 1С" — просмотр staging-таблиц после импорта из 1С.
 */
export async function setup(app: AppRuntime): Promise<void> {
  // Расширения регистрируются до инициализации навигации
  registerElitaDealViewExtensions();
  registerElitaWelcomeExtensions();
  registerElitaLeadViewExtensions();

  const elita = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
    navigationOrder: 5,
  });

  const groupExchange = elita.createNavigationGroup({
    key: 'exchange-1c',
    label: 'Обмен 1С',
    icon: IconRefresh,
    order: 2,
  });

  elita.useNavigation([
    {
      icon: IconClipboardList,
      label: 'Коммерческие предложения',
      url: '/elita/orders',
      component: lazy(() => import('./components/ElitaOrdersList')),
    },
    {
      group: groupExchange,
      icon: IconPackage,
      label: 'Товары',
      url: '/elita/products',
      component: lazy(() => import('./components/ElitaProductsList')),
    },
    {
      group: groupExchange,
      icon: IconTag,
      label: 'SKU',
      url: '/elita/skus',
      component: lazy(() => import('./components/ElitaSkusList')),
    },
    {
      group: groupExchange,
      icon: IconFolder,
      label: 'Категории',
      url: '/elita/categories',
      component: lazy(() => import('./components/ElitaCategoriesList')),
    },
    {
      group: groupExchange,
      icon: IconBuildingWarehouse,
      label: 'Склады',
      url: '/elita/warehouses',
      component: lazy(() => import('./components/ElitaWarehousesList')),
    },
    {
      group: groupExchange,
      icon: IconCoin,
      label: 'Типы цен',
      url: '/elita/price-types',
      component: lazy(() => import('./components/ElitaPriceTypesList')),
    },
    {
      group: groupExchange,
      icon: IconList,
      label: 'Типы реквизитов',
      url: '/elita/requisite-types',
      component: lazy(() => import('./components/ElitaRequisiteTypesList')),
    },
    {
      group: groupExchange,
      icon: IconListDetails,
      label: 'Атрибуты',
      url: '/elita/attributes',
      component: lazy(() => import('./components/ElitaAttributesList')),
    },
    {
      icon: IconAdjustments,
      label: 'Значения атрибута',
      url: '/elita/attributes/:id',
      hiddenFromMenu: true,
      component: lazy(() => import('./components/ElitaAttributeDetailPage')),
    },
    {
      icon: IconPackage,
      label: 'Товар',
      url: '/elita/products/:id',
      hiddenFromMenu: true,
      component: lazy(() => import('./components/ElitaProductView')),
    },
  ]);
}
